<div class="info" (click)="tooltipHandler()">
  <div class="btv-icon-info theme-input__counterIconInfo"></div>
</div>

@if (isTooltipOpen) {
  <div class="tooltip theme-input__counterTooltip">
    <div class="bm--dropdown-triangle bm--dropdown-triangle--tooltip theme-input__counterTooltip"></div>
    <div class="tooltip__info-text bm--scroll-bar">
      @if (lang === 'en') {
        <p>Address: Street, Unit/Apartment, City or Town, State or Province, Country, Zip code</p>
        <p>Example: 775 Westminster Avenue APT D5, Brooklyn, NY, USA, 11230</p>
      }
      @if (lang === 'ru') {
        <div class="tooltip-text-ru">
          <span>1. ФИО</span>
          <p>Иванов Иван Иванович</p>
        </div>
        <div class="tooltip-text-ru">
          <span>2. Паспортные данные</span>
          <div>
            <span class="tooltip-text-ru__country">Гражданин Российской Федерации</span>
            <p class="tooltip-text-ru__descr">
              Паспорт: серия 1111 номер 222222, выдан ОВД гор.Москвы, 17.08.2015г., код подразделения: 333-333
            </p>
          </div>
          <div>
            <span class="tooltip-text-ru__country">Гражданин Республики Беларусь</span>
            <p class="tooltip-text-ru__descr">Паспорт: серия 1111 номер 222222, выдан: Минским РОВД, 17.08.2015г.</p>
          </div>
          <div>
            <span class="tooltip-text-ru__country">Гражданин Республики Казахстан</span>
            <p class="tooltip-text-ru__descr">Паспорт: №33333333, выдан: 06.02.2012г.</p>
          </div>
          <div>
            <span class="tooltip-text-ru__country">Гражданин Украины</span>
            <p class="tooltip-text-ru__descr">
              Паспорт (или данные ИД карты): серия 1111 номер 222222, выдан: гор. Киев, 17.08.2015 г.
            </p>
          </div>
        </div>
      }
    </div>
  </div>
}
